export const MASKED_EMAIL = '******************';
